import React, { useState, useEffect } from "react";
import "./Home.scss";
import {
  FiMenu,
  FiSearch,
  FiPlay,
  FiHeart,
  FiFileText,
  FiThumbsUp,
  FiMessageSquare,
  FiGlobe,
  FiArrowRight,
  FiRotateCcw,
  FiCreditCard,
  FiHome,
  FiPhone,
  FiMail,
  FiTwitter,
  FiFacebook,
  FiLinkedin,
} from "react-icons/fi";
import {
  FaRegMoneyBillAlt,
  FaHeadset,
  FaUnlockAlt,
  FaGoogle,
  FaSpotify,
} from "react-icons/fa";
import { Link, NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { BASE_URL } from "../../config/";
import {
  fetchPlaylist,
} from "../../store/playList/actions";

const Home = (props) => {
  React.useEffect(() => {
    props.fetchPlaylist();
  }, []);
  const [menuOpen, setMenuOpen] = React.useState(false);
  const [navBg, setNavBg] = React.useState(false);
  const [search, setSearch] = React.useState("")
  const cards = [
    { img: "/images/bg/1.webp" },
    { img: "/images/bg/2.jpg" },
    { img: "/images/bg/3.jfif" },
    { img: "/images/bg/4.jfif" },
    // { img: "/images/bg/5.png" },
  ];

  const gener = [
    { img: "/images/bg/providence-doucet-wPaBwop_rSo-unsplash.jpg" },
    { img: "/images/bg/11-1.jpg" },
    { img: "/images/bg/18.jpg" },
    { img: "/images/bg/9-2.jpg" },
    // { img: "/images/bg/5.png" },
  ];

  const changeBackground = () => {
    if (window.scrollY >= 80) {
      setNavBg(true);
    } else {
      setNavBg(false);
    }
  };
  const handleSearch = () => {
    console.log("click in here")
  }

  window.addEventListener("scroll", changeBackground);

  return (
    <div className="Home">
      <div
        className={`nav fixed-top ${
          navBg ? "bg-white shadow-sm bg" : "bg-transparent"
        } `}
      >
        <div className="container-fluid d-flex justify-content-between align-items-center">
          <div className="d-flex justify-content-start align-items-center flex-1">
            <Link to="/" className="">
              <img className="logo shadow-sm" src="/images/logo/music.png" />
            </Link>
            <div style={{ width: 20 }} />
            <div id='search' className="search shadow-sm">
              <button className="search-btn">
                <FiSearch />
              </button>
              <input
                type="text"
                name=""
                id=""
                placeholder="Start your search: guitar..."
                value={search}
                onChange={(e)=>setSearch(e.target.value)}
              />
            </div>
              <button className="btn btn-primary ml-3 mr-3" onClick={()=>{
                search !== "" ?
                props.history.push(`/search/${search}`)
                : console.log("")
              }}>Search</button>
          </div>

          <div className="d-flex justify-content-center align-items-center ">
            <Link to="/login" className="link-white d-none d-lg-block">
              Become a Professional
            </Link>
            <div className="drop ml-4">
              <div
                className="menu"
                onClick={() => {
                  setMenuOpen(!menuOpen);
                }}
              >
                <FiMenu />
                {/* <img src="/images/bg/pp.png" alt="" /> */}
              </div>
              <div
                className={`dropdown shadow ${
                  menuOpen === false ? "active" : ""
                }`}
              >
                <Link to="/login" className="link">
                  Sign In
                </Link>
                <Link to="/signUp" className="link">
                  Sign Up
                </Link>
                <div className="devider d-block d-lg-none"></div>
                <Link to="/login" className="link  d-block d-lg-none">
                  Become a Professional
                </Link>
                <div className="devider"></div>
                <Link to="/" className="link">
                  FAQs
                </Link>
                <Link to="/" className="link">
                  privacy policy
                </Link>
                <Link to="/" className="link">
                  terms of use
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* top image sections */}
      <div className="top">
        <div
          id="carouselExampleControls"
          class="carousel slide"
          data-ride="carousel"
        >
          <div class="carousel-inner">
            <div class="carousel-item active">
              <img
                src="/images/bg/20-1.jpg"
                class="d-block w-100 carousel-images"
                alt="..."
              />
              <div class="carousel-caption d-none d-lg-block">
                <div className="d-flex justify-content-center align-items-center flex-column content">
                  <h1>Want To Learn Music From The Comfort Of Your Home?</h1>
                  <div className="btn btn-primary">Let's Get Started</div>
                </div>
              </div>
            </div>
            <div class="carousel-item">
              <img
                src="/images/bg/11-1.jpg"
                class="d-block w-100 carousel-images"
                alt="..."
              />
              <div class="carousel-caption d-none d-lg-block">
                <div className="d-flex justify-content-center align-items-center flex-column content">
                  <h1>Want To Learn Music From The Comfort Of Your Home?</h1>
                  <div className="btn btn-primary">Let's Get Started</div>
                </div>
              </div>
            </div>
            <div class="carousel-item">
              <img
                src="/images/bg/17-2.jpg"
                class="d-block w-100 carousel-images"
                alt="..."
              />
              <div class="carousel-caption d-none d-lg-block">
                <div className="d-flex justify-content-center align-items-center flex-column content">
                  <h1>Want To Learn Music From The Comfort Of Your Home?</h1>
                  <div className="btn btn-primary">Let's Get Started</div>
                </div>
              </div>
            </div>
          </div>
          <a
            class="carousel-control-prev"
            href="#carouselExampleControls"
            role="button"
            data-slide="prev"
          >
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a
            class="carousel-control-next"
            href="#carouselExampleControls"
            role="button"
            data-slide="next"
          >
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
        {/* <div
          className="jumbotron position-relative"
          style={{
            backgroundImage:
              "linear-gradient(180deg,#551a8baa, #9966cc22), url(/images/bg/priscilla-du-preez-NP3KdAQc6c4-unsplash.jpg)",
          }}
        >
          <div className="d-flex justify-content-center align-items-center flex-column content">
            <h1>Want To Learn Music From The Comfort Of Your Home?</h1>
            <div className="btn btn-primary">Let's Get Started</div>
          </div>
        </div> */}
        <img src="/images/curve.png" alt="" className="bg-img" />
      </div>
      {/*  */}

      <section className="about">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="d-flex justify-content-start align-items-start flex-column  ">
                <h1 className="section-subtitle text-red  header left">
                  {" "}
                  What We Do Best{" "}
                </h1>

                <p className="text-left">
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit, do
                  eius mod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad min im veniam, quis nostrud exercitati ullamco
                  laboris nisi ut aliquip ex ea commodo consequat.
                </p>
                <a href="#" className="btn btn-primary btn-round">
                  See our stadies
                </a>
              </div>
            </div>
            <div className="col-lg-6">
              <img
                className="about-img"
                src="/images/bg/home2-illustration.svg"
                alt=""
                className="img-left"
              />
            </div>
          </div>
        </div>
      </section>
      {/*  */}

      {/*  */}
      <section
        style={{
          backgroundImage:
            "linear-gradient(45deg, #fafafafe, #fafafafe), url(/images/bg/3.jfif)",
        }}
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-3 col-6">
              <div className="counter-item">
                <h5 className="counter-number text-grad">
                  <span className="counter">1M</span>{" "}
                </h5>
                <p className="counter-name"> members </p>
              </div>
            </div>
            <div className="col-lg-3  col-6">
              <div className="counter-item">
                <h5 className="counter-number text-grad ">
                  <span className="counter">20K</span>{" "}
                </h5>
                <p className="counter-name"> tutors </p>
              </div>
            </div>
            <div className="col-lg-3  col-6">
              <div className="counter-item">
                <h5 className="counter-number text-grad ">
                  <span className="counter">20M</span>
                </h5>
                <p className="counter-name"> points </p>
              </div>
            </div>
            <div className="col-lg-3  col-6">
              <div className="counter-item">
                <h5 className="counter-number counter text-grad">50</h5>
                <p className="counter-name"> partners </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*  */}

      <section
        className=""
        style={{
          backgroundImage:
            "linear-gradient(180deg,#551a8bee, #9966cc88), url(/images/bg/3.jfif)",
        }}
      >
        <h1 className="header text-sm text-white">Featured Sessions</h1>
        <div className="container mt-5 pt-5">
          {props.playlist.length > 0 && (
          <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-4">
            {props.playlist.slice(0, 4).map((item, i) => (
              <div className="col mb-5 mb-lg-0" key={i}>
                <div className="card h-100 shadow-sm ">
                  <img src={`${BASE_URL}uploads/${item.banner}`} className="card-img-top" alt="..." />
                  <div className="card-body">
                    <Link to={props?.profile?._id ? `/course-detail/${item._id}` : '/login'} className="play">
                      <FiPlay />
                    </Link>
                    <h5 className="card-title h2 font-weight-bold ">
                    {item.title}
                    </h5>
                    <div className="h3 font-weight-bold text-success mt-2 mb-3">
                      $ {item.price}
                    </div>
                    <p className="card-text text-muted font-weight-light h5 ">
                    {item.description}
                    </p>
                  </div>
                  <div className="card-footer bg-white ">
                    <div className="h5 font-weight-light footer-text">
                      {" "}
                      4 Lectures | {item.duration} hr | <Link to={props?.profile?._id ? item.created_by._id === props?.profile?._id ? `/profile/` : `/view-profile/${item.created_by._id}` : '/login'}>{item.created_by.name}</Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          )}
        </div>
      </section>
      {/*  */}
      {/*  */}
      <section className="">
        <h1 className="header text-sm">Live Sessions</h1>
        <div className="container mt-5 pt-5">
          <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-4">
            {cards.map((item, i) => (
              <div className="col mb-5 mb-lg-0" key={i}>
                <div className="card h-100 shadow-sm ">
                  <img src={`${item.img}`} className="card-img-top" alt="..." />
                  <div className="card-body">
                    <Link to="/course-detail/name" className="play">
                      <FiPlay />
                    </Link>
                    <h5 className="card-title h2 font-weight-bold ">
                      Piano For Beginners
                    </h5>
                    <div className="h3 font-weight-bold text-success mt-2 mb-3">
                      $ 500
                    </div>
                    <p className="card-text text-muted font-weight-light h5 ">
                      This is a wider card with supporting text below as a
                      natural lead-in to additional content. This content is a
                      little bit longer.
                    </p>
                  </div>
                  <div className="card-footer bg-white ">
                    <div className="h5 font-weight-light footer-text">
                      {" "}
                      4 Lectures | 40 hr | John Doe{" "}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/*  */}
      {/*  */}
      <section
        className="bg-gradient gener-container"
        style={{
          backgroundImage:
            "linear-gradient(180deg,#551a8bee, #9966cc88), url(/images/bg/17-3.jpg)",
        }}
      >
        <h1 className="header text-white text-sm">Choose your genre</h1>
        <div className="container mt-5 pt-5">
          <div className="row row-cols-1 row-cols-lg-3 row-cols-lg-4 g-4">
            {gener.map((item, i) => (
              <div className="col-6 col-lg-3" key={i}>
                <div className="card gener shadow-sm ">
                  <img src={`${item.img}`} className="card-img-top" alt="..." />
                  <div className="card-body">
                    <h5 className="card-title h2 font-weight-bold ">
                      Folk Culture
                    </h5>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/*  */}

      <section className="feature">
        <div className="container">
          <div className="header text-sm ">Explore Our Features</div>
          <div className="row">
            <div className="col-12 col-md-4 col-lg-4">
              <div className="feature-card">
                <FiFileText />
                <div className="h4">Learn & Earn</div>
              </div>
            </div>
            <div className="col-12 col-md-4 col-lg-4">
              <div className="feature-card">
                <FaRegMoneyBillAlt />
                <div className="h4">Pay After Your Session</div>
              </div>
            </div>
            <div className="col-12 col-md-4 col-lg-4">
              <div className="feature-card">
                <FiThumbsUp />
                <div className="h4">Experienced Tutors</div>
              </div>
            </div>
            <div className="col-12 col-md-4 col-lg-4">
              <div className="feature-card">
                <FiGlobe />
                <div className="h4">Worldwide Connections</div>
              </div>
            </div>
            <div className="col-12 col-md-4 col-lg-4">
              <div className="feature-card">
                <FiPlay />
                <div className="h4">Video Conferencing</div>
              </div>
            </div>
            <div className="col-12 col-md-4 col-lg-4">
              <div className="feature-card">
                <FiMessageSquare />
                <div className="h4">Chat Together</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*  */}
      {/*  */}

      <section
        className="Works"
        style={{
          backgroundImage:
            "linear-gradient(180deg,#551a8bee, #9966cc55), url(/images/bg/307.jpg)",
        }}
      >
        <div className="container">
          <div className="header text-sm text-white">Here’s How It Works</div>
          <div className="row">
            <div className="col-12 col-md-6 col-lg-4">
              <div className="Works-card">
                <div className="no">01</div>
                <div className="">
                  <div className="h4">Create Account</div>
                  <small>
                    Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                    Praesentium consequatur deserunt delectus
                  </small>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="Works-card">
                <div className="no">02</div>
                <div className="">
                  <div className="h4">Edit Profile</div>
                  <small>
                    Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                    Praesentium consequatur deserunt delectus
                  </small>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="Works-card">
                <div className="no">03</div>
                <div className="">
                  <div className="h4">Add Payment method</div>
                  <small>
                    Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                    Praesentium consequatur deserunt delectus
                  </small>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="Works-card">
                <div className="no">04</div>
                <div className="">
                  <div className="h4">Schedule Session</div>
                  <small>
                    Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                    Praesentium consequatur deserunt delectus
                  </small>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="Works-card">
                <div className="no">05</div>
                <div className="">
                  <div className="h4">Offer Session</div>
                  <small>
                    Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                    Praesentium consequatur deserunt delectus
                  </small>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="Works-card">
                <div className="no">06</div>
                <div className="">
                  <div className="h4">Rate Your Experience</div>
                  <small>
                    Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                    Praesentium consequatur deserunt delectus
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*  */}
      {/*  */}

      <section className="Payments">
        <div className="container">
          <div className="header text-sm ">
            Our Unique Points-Based Payments
          </div>
          <div className="row">
            <div className="col-12 col-md-6 col-lg-3">
              <div className="Payments-card">
                <FiCreditCard />
                <div className="h4">Highly Effective Payment Method</div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-3">
              <div className="Payments-card">
                <FaUnlockAlt />
                <div className="h4">Highly Secure</div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-3">
              <div className="Payments-card">
                <FaHeadset />
                <div className="h4">Fiduciary Accounts Support</div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-3">
              <div className="Payments-card">
                <FiRotateCcw />
                <div className="h4">Completely Refundable</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*  */}
      {/*  */}
      <section
        className="testemonial"
        style={{
          backgroundImage:
            "linear-gradient(180deg,#fffffffa, #ffffffee), url(/images/bg/IMG_8746-1024x683.jpg)",
        }}
      >
        <h1 className="header text-sm">Feedback From Our Members</h1>
        <div className="container mt-5 pt-5">
          {/*  */}
          <div className="testemonial-card">
            <div className="balanced">
              <img src="/images/bg/pp.png" alt="" />
              <div className="msg">
                <div className="para">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Doloribus sint suscipit eaque accusantium ipsa, architecto
                  rerum quaerat modi expedita fugit mollitia, qui nihil id magni
                  dolorem assumenda repellendus temporibus nostrum.
                </div>
                <div className="author">- Robert Donald</div>
              </div>
            </div>
          </div>
          {/*  */}
          {/*  */}
          <div className="testemonial-card">
            <div className="balanced">
              <img src="/images/bg/pp.png" alt="" />
              <div className="msg">
                <div className="para">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Doloribus sint suscipit eaque accusantium ipsa, architecto
                  rerum quaerat modi expedita fugit mollitia, qui nihil id magni
                  dolorem assumenda repellendus temporibus nostrum.
                </div>
                <div className="author">- Robert Donald</div>
              </div>
            </div>
          </div>
          {/*  */}
        </div>
      </section>
      {/*  */}
      {/*  */}
      <section
        className="bg-gradient gener-container"
        style={{
          backgroundImage:
            "linear-gradient(180deg,#551a8bee, #9966cc88), url(/images/bg/IMG_8746-1024x683.jpg)",
        }}
      >
        <h1 className="header text-white text-sm">Register Now!</h1>
        <h4 className="text-white font-weight-light">
          Create a free account and get started
        </h4>
        <div className="container mt-5 pt-5">
          <div className="btn btn-light btn-lg">
            Register Now <FiArrowRight />
          </div>
        </div>
      </section>
      {/*  */}
      {/*  */}
      <div className="footer bg-dark text-white py-5">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-3">
              <Link to="/" className="">
                <img className="logo shadow-sm" src="/images/logo/music.png" />
              </Link>
            </div>
            <div className="col-12 col-lg-3 flex-column-center-mobile">
              <div className="header">Contact Information</div>
              <div className="ul">
                <div className="d-flex li">
                  <FiHome />
                  <div className="text">
                    Plant B. Manager 71 Old Church St Kensington, SW3 5BS
                  </div>
                </div>
                <div className="d-flex li">
                  <FiPhone />
                  <div className="text">0845 054 7101</div>
                </div>
                <div className="d-flex li">
                  <FiMail />
                  <div className="text">contact@example.com</div>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-3 flex-column-center-mobile">
              <div className="header">Helpful Links</div>
              <div className="ul">
                <div className="d-flex li">
                  <Link to="/" className="text">
                    About Us
                  </Link>
                </div>
                <div className="d-flex li">
                  <Link to="/" className="text">
                    Services
                  </Link>
                </div>
                <div className="d-flex li">
                  <Link to="/" className="text">
                    Point System
                  </Link>
                </div>
                <div className="d-flex li">
                  <Link to="/" className="text">
                    Testimonials
                  </Link>
                </div>
                <div className="d-flex li">
                  <Link to="/signup" className="text">
                    Sign Up
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-3 flex-column-center-mobile">
              <div className="header">Keep Connected</div>
              <div className="ul d-flex">
                <div className="d-flex li">
                  <Link to="/" className="text">
                    <FiFacebook />
                  </Link>
                </div>
                <div className="d-flex li">
                  <Link to="/" className="text">
                    <FiTwitter />
                  </Link>
                </div>
                <div className="d-flex li">
                  <Link to="/" className="text">
                    <FaGoogle />
                  </Link>
                </div>
                <div className="d-flex li">
                  <Link to="/" className="text">
                    <FiLinkedin />
                  </Link>
                </div>
                <div className="d-flex li">
                  <Link to="/" className="text">
                    <FaSpotify />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  playlist: state.playlist.playlist,
  profile: state.profile.profile
});

export default connect(mapStateToProps, {
  fetchPlaylist,
})(Home);